import React from 'react';

import { FreeTrialWrapper } from '../../components/free-trial-wrapper';

import { TrialStartContent } from './components';

export const TrialStart = () => (
  <FreeTrialWrapper>
    <TrialStartContent />
  </FreeTrialWrapper>
);
